import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MateriomLogo from "../ui/MateriomLogo";
import { createAuthLayoutStyles } from "./styles";

/**
 * Props for the AuthLayout component.
 *
 * @param children - The React node(s) to be rendered inside the authentication layout.
 */
interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * Authentication Layout Component
 *
 * Provides the common layout for authentication pages including:
 * - Background image on the left side
 * - Materiom logo positioning
 * - Responsive container for form content
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  // Styles
  const theme = useTheme();
  const authLayoutStyles = createAuthLayoutStyles(theme);

  return (
    <Box sx={authLayoutStyles.container}>
      {/* Logo */}
      <MateriomLogo sx={authLayoutStyles.logo} />

      {/* Background Image - Left Side */}
      <Box sx={authLayoutStyles.backgroundImage} />

      {/* Form Content Area */}
      {children}
    </Box>
  );
};

export default AuthLayout;
